import Button from '@material-ui/core/Button'
import { Auth } from 'aws-amplify'
import React, { useState } from 'react'
import { deviceType, isMobile, isTablet } from 'react-device-detect'
import WebFooter from '../../source/WebScreen/WebFooter'
import '../authentication/Login.css'
import { getQueryParams } from '../authentication/utils'
import InputPassword from './InputPasswordBox'
import PasswordValidations from './PwdValidations'
import { isEqual } from 'lodash';
import { getUser, getUserDetails } from '../../actions/homeActions'

function ResetPasswordForm(props) {
  const [verificationCode, setVerification] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [disableSendBtn, setDisableSendBtn] = useState(true)

  const handleConfirmVerification = e => {
    e.preventDefault()
    console.log('calling reset')
    console.log(props.email)
    console.log(verificationCode)
    console.log(password)
    if (isEqual(password, confirmPassword)) {
      props.toggleLoader(true)
      Auth.completeNewPassword(props.user, password)
        .then(user => {
          console.log(user)
          // props.toggleLoader(false)
          let queryParams = getQueryParams()
          console.log(queryParams)
          if (queryParams.u) {
            let userName = decodeURI(queryParams.u)
            let url = window.location.href.split('?')[0] + '?u=' + userName + '&p=' + password
            // props.otpScreen()
             getUserDetailsCall()
          } else {
            // props.otpScreen()
            getUserDetailsCall()
          }
        })
        .catch(err => {
          props.toggleLoader(false)
          console.log(err.message)
          setErrorMessage(err.message)
        })
    } else {
      setErrorMessage('Please enter same password')
    }
  }

  const getUserDetailsCall = async () => {
    try {
      var email =
        props &&
        props.user &&
        props.user.challengeParam &&
        props.user.challengeParam.userAttributes &&
        props.user.challengeParam.userAttributes.email || "";
      let userData = await getUserDetails(email)
        if (userData) {
          let find = userData.data.memberIdCardList[userData.data.memberIdCardList.length - 1]
          localStorage.setItem('SOURCE', find.source)
          localStorage.setItem('sourceid', userData.data.memberIdCardList[0].memberId);
          localStorage.setItem('planId', userData.data.memberIdCardList[0].planId)
          localStorage.setItem('subscriberName',`${userData.data.memberIdCardList[0].prefix || ""} ${userData.data.memberIdCardList[0].firstName} ${userData.data.memberIdCardList[0].middleName || ""} ${userData.data.memberIdCardList[0].lastName} ${userData.data.memberIdCardList[0].suffix || ""}`.toUpperCase())
          if (userData.data.memberIdCardList[0].guardian) {
            localStorage.setItem('isGuardian', "true")
            localStorage.setItem('guardianName', `${userData.data.memberIdCardList[0].guardian.prefix || ""} ${userData.data.memberIdCardList[0].guardian.firstName} ${userData.data.memberIdCardList[0].guardian.middleName||""} ${userData.data.memberIdCardList[0].guardian.lastName} ${userData.data.memberIdCardList[0].guardian.suffix || ""}`)
          }
          localStorage.setItem('CLIENT_ID', find.clientId)
          let contact = userData.data.memberIdCardList[userData.data.memberIdCardList.length - 1].planInfo.find(
            obj => obj.idcardField == 'contact number'
          )
          contact ? localStorage.setItem('CONTACT_NUMBER', contact.fieldValue) : localStorage.setItem('CONTACT_NUMBER', 'NA')
        }
        window.location.reload()

      return userData
    } catch (error) {
      console.error("Error fetching user details:", error)
      throw error
    }
  }

  const handleChange = e => {
    if (e.target.name == 'password') {
      setPassword(e.target.value)
    } else if (e.target.name == 'confirmPassword') {
      setConfirmPassword(e.target.value)
    }
  }
  const toggleResetBtn = allPassed => {
    setDisableSendBtn(!allPassed)
  }

  return (
    <div>
      {deviceType == 'browser' && (isMobile == false || isMobile == 'false') && (isTablet == false || isTablet == 'false') ? (
        <form className="main-form">
          <div class="rege">
            <div class="rege_container">
            <div className="loginform_containernetwell">
                <div class="h_left_icon_div" >
                  <img src={require('../../source/Images/HomeIcon/netwell-logo.png')} className="netwell_logo"/>
                </div>
                  <img src={require('../../source/Images/Banner/welcome_image_netwell.png')} className="login_main_image_netwell" />
              </div>

              <div class="firsttime_changepassword_text">Change Password</div>
              <div class="firsttime_changepassword_subtext">Please enter your new password below.</div>

              <p className="reset_errormsg" hidden={errorMessage.length <= 0} style={{}}>
                {errorMessage}
              </p>

              <div class="reset_container">
                <div className="a-form-ctrl_web firsttime_margin_class">
                  <p className="">New Password</p>
                  <InputPassword handleChange={handleChange} name={'password'} />
                </div>

                <div className="a-form-ctrl_web firsttime_margin_class">
                  <p className="">Enter New Password Again</p>
                  <InputPassword handleChange={handleChange} name={'confirmPassword'} />
                </div>
              </div>
              <button type="submit" className="firsettime_send_button" onClick={handleConfirmVerification}>
                Send
              </button>

              <div class="mb-3">
                <PasswordValidations password={password} allPassed={toggleResetBtn} />
              </div>
              <WebFooter />
            </div>
          </div>
        </form>
      ) : (
        <div class="loginmobile">
          <div class="loginmobile_header">
            <div class="loginmobile_header_text">Member Portal</div>
          </div>

            <form>
            <div className="loginform_containernetwell">
                  
                  <img src={require('../../source/Images/HomeIcon/netwell-logo.png')} className="netwell_logo_mobile"/>
               
                  <img src={require('../../source/Images/Banner/family-looking-at-tablet_1.jpeg')} className="login_main_image_netwell" />
                </div>
          <div class="loginmobile_container">

              <div class="firsttimemobile_bottom_text">
                <div class="firsttimemobile_bottom_subtext">Change Password</div>
                <div class="firsttimemobile_bottom_subtext2">
                  <div>Please enter your new passsword below.</div>
                </div>
              </div>

              <div class="loginmobile_input_container">
                <p className="a-errorMessage" hidden={errorMessage.length <= 0} style={{ marginTop: '10px' }}>
                  {errorMessage}
                </p>

                <div class="mobile-linput"></div>
                <div style={{ position: 'relative', marginBottom: '40px' }}>
                  <InputPassword handleChange={handleChange} name={'password'} placeholder="NEW PASSWORD" />
                </div>

                <div style={{ position: 'relative', marginBottom: '30px' }}>
                  <InputPassword handleChange={handleChange} name={'confirmPassword'} placeholder="NEW PASSWORD AGAIN" />
                </div>

                <Button type="submit" variant="contained" color="" class="loginmobile_button" onClick={handleConfirmVerification}>
                  Send
                </Button>
              </div>

              <div className="mt-3 passowrd_validation_center">
                <PasswordValidations password={password} allPassed={toggleResetBtn} />
              </div>
        </div>
            </form>
          </div>
      )}
    </div>
  )
}

export default ResetPasswordForm
